import { render, staticRenderFns } from "./MenuSocialWorker.vue?vue&type=template&id=7b21a82b&"
import script from "./MenuSocialWorker.vue?vue&type=script&lang=js&"
export * from "./MenuSocialWorker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports